import React from 'react'
import { CustomModal } from '../CustomModal/CustomModal'
import errorIcon from '../../assets/icons/triangule-exclamation.svg';
import { t } from 'i18next';
import { Button, Spinner } from 'reactstrap';
import { ButtonWhite } from '../Buttons/ButtonWhite';

export const DeleteModal = ({ showModal, setShowModal, deleteFunction, areYouSureMessage = '', deleting = false }) => {
    return (
        <CustomModal
            showModal={showModal}
            centered
            setShowModal={setShowModal}
        >
            <div className='d-flex flex-column align-items-center justify-content-center'>
                <img
                    src={errorIcon}
                    alt="errorIcon"
                />
                <p className='mt-3 text-center param-section-title'>
                    {t('ARE_YOU_SURE_DELETE')} {areYouSureMessage}
                </p>
            </div>
            <div className={`d-flex align-items-center justify-content-${deleting ? 'center' : 'around'}`}>
                {
                    deleting ?
                        <Spinner />
                        :
                        <>
                            <div>
                                <ButtonWhite
                                    className='text-dark shadow-none'
                                    onClick={setShowModal}
                                >
                                    {t('CANCEL')}

                                </ButtonWhite>
                            </div>
                            <div>
                                <Button
                                    color='danger'
                                    onClick={deleteFunction}
                                >
                                    {t('DELETE')}
                                </Button>
                            </div>
                        </>
                }
            </div>
        </CustomModal >

    )
}
